<template lang="pug">
button.briq-button.type-bold(:type="type" :class="extraClasses" v-on="$listeners" v-bind="$attrs")
  slot
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'main',
      validator: variant => {
        const variantIsKnown =
          variant === 'main' ||
          variant === 'red' ||
          variant === 'secondary' ||
          variant === 'text' ||
          variant === 'dark' ||
          variant === 'dark-2'
        if (!variantIsKnown) console.error(`unknown button variant ${variant}`)
        return variantIsKnown
      },
    },
    active: Boolean,
    small: Boolean,
    wide: Boolean,
    jumbo: Boolean,
    submit: Boolean,
  },
  computed: {
    extraClasses() {
      return {
        'button-main': this.variant === 'main',
        'button-red': this.variant === 'red',
        'button-secondary': this.variant === 'secondary',
        'button-dark': this.variant === 'dark',
        'button-dark-2': this.variant === 'dark-2', // used for booking details quick actions
        'button-text': this.variant === 'text',
        'button-large': !this.small,
        'button-active': this.active,
        'button-jumbo': this.jumbo,
        wide: this.wide,
      }
    },
    type() {
      return this.submit ? 'submit' : 'button'
    },
  },
}
</script>

<style scoped lang="stylus">
buttonRed = #ea3535
buttonDarkRed = #cc2323
buttonDisabledGrey = #cacfd6
button-secondary = white
button-secondary-border = #E2E2E2
button-secondary-border-hover = #D3D3D3

.briq-button
  display inline-block
  border-radius 3px
  padding 2px 12px
  border 1px solid transparent
  margin-bottom 0
  text-align center
  vertical-align middle
  touch-action manipulation
  cursor pointer
  background-image none
  white-space nowrap
  text-decoration none
  transition all .03s ease-in

  &:hover, &:focus, &:active
    outline 0
    text-decoration none

  &.wide
    min-width 110px

  &.button-large
    padding 7px 15px

  &.button-jumbo
    padding 15px
    display block
    width 100%

  &.button-main
    border-color #008ce8
    background-color #009BFF
    color #fff

    &:hover, &:focus
      background-color #008ce8

  &.button-red
    border-color buttonDarkRed
    background-color buttonRed
    color #fff

    &:hover, &:focus
      background-color buttonDarkRed

  &.button-secondary
    border-color button-secondary-border
    background-color button-secondary
    color #2c333a

    &:hover, &:focus
      border-color button-secondary-border-hover
      background-color button-secondary

    &.button-active
      background-color #4E5A6A
      color #ffffff
      font-weight 500

      &:hover, &:focus
        background-color #798696

      &:disabled
        background-color buttonDisabledGrey

  &.button-dark
    border-color #4E5A6A
    background-color #4E5A6A
    color #fff

    &:hover, &:focus
      border-color #121D32
      background-color #121D32

    &.button-active
      background-color #121D32
      color #ffffff
      font-weight 500

      &:hover, &:focus
        background-color #798696

      &:disabled
        background-color buttonDisabledGrey

  &:disabled
    background-color buttonDisabledGrey
    border-color buttonDisabledGrey
    color white
    cursor not-allowed

    &:hover, &:focus
      background-color buttonDisabledGrey
      border-color buttonDisabledGrey

  &.button-text
    opacity .4
    border-color transparent
    background transparent
    color #2c333a

    &:hover, &:focus
      opacity .5

    &:disabled
      border-color transparent
      background transparent
      color #2c333a
      cursor not-allowed

      &:hover, &:focus
        border-color transparent
        background transparent
        color #2c333a

  &.button-dark-2
    background #1e283c
    border none
    color #fff

    &:hover
      background #4E5A6A

  &.pending
    cursor wait
</style>
